// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/VendasKpi_CardsResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * Response contract for GET /dashboards/vendas_kpi/cards.
 *
 * All monetary values are int CENTAVOS. Percentages are basis points (bp)
 * where 10000 = 100%. Ratios (itens_por_cliente, meta_itens_dia, etc.)
 * are int * 100 for two decimal places.
 *
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface VendasKpi_CardsResponseDados {
meta_faturamento: number
meta_itens: number
dias_uteis: number
vendas_realizadas: number
recebido_no_periodo: number
itens_realizados: number
clientes_atendidos: number
previsao_vendas: number
itens_previstos: number
ticket_medio_geral: number
ticket_medio_item: number
meta_itens_dia: number
media_diaria_realizada: number
itens_em_atraso: number
percentual_atingimento: number
itens_por_cliente: number
}

export type VendasKpi_CardsResponse = ApiResponse<VendasKpi_CardsResponseDados>;

registerResponseContract('VendasKpi_CardsResponse', {
  meta_faturamento:       { type: 'number',  required: true },
  meta_itens:             { type: 'number',  required: true },
  dias_uteis:             { type: 'number',  required: true },
  vendas_realizadas:      { type: 'number',  required: true },
  recebido_no_periodo:    { type: 'number',  required: true },
  itens_realizados:       { type: 'number',  required: true },
  clientes_atendidos:     { type: 'number',  required: true },
  previsao_vendas:        { type: 'number',  required: true },
  itens_previstos:        { type: 'number',  required: true },
  ticket_medio_geral:     { type: 'number',  required: true },
  ticket_medio_item:      { type: 'number',  required: true },
  meta_itens_dia:         { type: 'number',  required: true },
  media_diaria_realizada: { type: 'number',  required: true },
  itens_em_atraso:        { type: 'number',  required: true },
  percentual_atingimento: { type: 'number',  required: true },
  itens_por_cliente:      { type: 'number',  required: true },
})
